import styles from './navbar.module.scss'
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { HomeOutlined, RightOutlined } from '@ant-design/icons';
import { Locaiotn } from '../utils/enum'
import { setLang, getLangName as t } from '../utils/index'
import zhPng from '../assets/images/zh.png'
import enPng from '../assets/images/en.png'
import logoPNG from '../assets/images/logo.png' 
// import Modal from './Modal'
function Navbar() {
  const [isShow, setIsShow] = useState(null);
  const lang = localStorage.getItem('lang') || 'CN';
  const { pathname } = useLocation();
  const pathKEey = pathname.split('/')[1];
  const LcName = Locaiotn[pathKEey]
  const navigate = useNavigate();
  const handleNavi = (path) => {
    navigate(path);
  }
  const handleTriggerLang = (lang) => {
    setLang(lang);
  }

  const handleShowModal = (code) => {
    if (code === 'case' || code === 'contact' || code === 'home') {
      setIsShow(null);
    }
    if (code === 'product') {
      setIsShow(code);
      return;
    }
  }

  const handleHideModal = () => {
    setIsShow(null);
  }
  return (
    <>
      {/* {isShow && <Modal code={isShow} onHideModal={handleHideModal} />} */}
      <nav className={styles.nav}>
        <img src={logoPNG} />
        <div className={styles.nav_ul}>
          <div className={pathKEey === 'contactUs' ? styles.nav_li_ac : styles.nav_li} onMouseEnter={() => handleShowModal('contact')} onClick={() => handleNavi('/contactUs')}>{t('contact')}</div>
          {/* <div className={pathKEey === 'settings' ? styles.nav_li_ac : styles.nav_li} onMouseEnter={() => handleShowModal('case')} onClick={() => handleNavi('/settings')}>{t('case')}</div> */}
          <div className={pathKEey === 'productCenter' ? styles.nav_li_ac : styles.nav_li} onMouseEnter={() => handleShowModal('product')} onClick={() => handleNavi('/productCenter')}>{t('product')}</div>
          <div className={pathKEey === 'aboutCompany' ? styles.nav_li_ac : styles.nav_li} onClick={() => handleNavi('/aboutCompany')}>{t('aboutCompany')}</div>
          <div className={styles.nav_li} onMouseEnter={() => handleShowModal('home')} onClick={() => handleNavi('/')}>{t('home')}</div>
        </div>
        <div className={styles.nav_lang}>
          {lang === 'CN' && <img src={zhPng} alt="zh" onClick={() => handleTriggerLang('EN')} />}
          {lang === 'EN' && <img src={enPng} alt="en" onClick={() => handleTriggerLang('CN')} />}
        </div>
        {LcName && <div className={styles.nav_float}>
          <HomeOutlined style={{
            marginRight: '15px',
            color: '#707070'
          }} onClick={() => handleNavi('/')} />
          <RightOutlined style={{
            marginRight: '15px',
            color: '#707070'
          }} />
          <span>{LcName}</span>
        </div>}
      </nav>
    </>
  );
}

export default Navbar;